module.exports = __webpack_public_path__ + "img/cookie.be5030ca.webp";